import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { Activity } from "@modules/activities/types";

export function useActivityList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createActivityModalRef = useRef<ModalRef>(null);
  const editActivityModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps }  = usePaginatedTable<Activity>({
    resource: "v1/activity_admin",
    filters: getQueryParams(),
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createActivityModalRef,
    editActivityModalRef,
    refetch,
    setSelectedRows,
    translate,
  };
}
